import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Typography, Tabs } from "antd";
import FeeTable from "../table/FeeTable";
import ExpensesTable from "../table/ExpensesTable";
import UnpaidFeeTable from "../table/UnpaidFeeTable";
import UnpaidExpensesTable from "../table/UnpaidExpensesTable";
import AddEditExpenseModal from "../modals/AddEditExpenseModal";
import { Expense } from "types/expenseTypes";
import StudentFeesTable from "../table/StudentFeesTable";
import useExpense from "../hooks/useExpense";
import useFee from "../hooks/useFee";
import useFinanceStats from "../hooks/useFinanceStats";
import { useAbility } from "config/abilityContext";

const { Text } = Typography;
const { TabPane } = Tabs;

interface Props {
  feeData: any[];
  expenseData: any[];
  unpaidFeeData: any[];
  unpaidExpenseData: any[];
}

const OverviewTabs: React.FC<Props> = ({
  feeData,
  expenseData,
  unpaidFeeData,
  unpaidExpenseData,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const ability = useAbility();

  const handleSaveExpense = async (expenseData: any) => {
    // Handle save logic here
    console.log("Saving expense:", expenseData);
  };

  const handleEdit = (record: any) => {
    setSelectedExpense(record);
    setIsModalOpen(true);
  };

  const handleDelete = (id: string) => {
    console.log("Deleting expense:", id);
  };

  const {  handleDelete : handleDeleteExpense } = useExpense();
  const { handleDelete : handleDeleteFee } = useFee();

  const { fetchFinanceOverview } = useFinanceStats();

  const handleDeleteExpenseWithRefresh = async (id: string) => {
    await handleDeleteExpense(id);
    fetchFinanceOverview();
  };

  const handleDeleteFeeWithRefresh = async (id: string) => {
    await handleDeleteFee(id);
    fetchFinanceOverview();
  };

  return (
    <>
      <Tabs defaultActiveKey={ability.can("getAll", "Fee") ? "1" : "2"} tabBarStyle={{ color: "primary" }}>
        {ability.can("getAll", "Fee") && (
        <TabPane tab={t("fees")}  key="1">
          <StudentFeesTable dataSource={feeData} onEdit={handleEdit} onDelete={handleDeleteFeeWithRefresh} loading={false}  hideActions={true}/>
        </TabPane>
        )}

        {ability.can("getAll", "Expense") && (
        <TabPane tab={t("expenses")} key="2">
          <ExpensesTable dataSource={expenseData} onEdit={handleEdit} onDelete={handleDeleteExpenseWithRefresh} loading={false} hideActions={true} />
        </TabPane>
        )}

        {ability.can("getAll", "Fee") && (
        <TabPane tab={t("unpaid_fees")} key="3">
          <StudentFeesTable dataSource={unpaidFeeData} onEdit={handleEdit} onDelete={handleDeleteFeeWithRefresh} loading={false} hideActions={true} />
        </TabPane>
        )}

        {ability.can("getAll", "Expense") && (
        <TabPane tab={t("unpaid_expenses")} key="4">
        <ExpensesTable dataSource={unpaidExpenseData} onEdit={handleEdit} onDelete={handleDeleteExpense} loading={false} hideActions={true} />
        </TabPane>
        )}
      </Tabs>
      {/* <AddEditExpenseModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        expenseData={selectedExpense}
        onSave={handleSaveExpense}
        suppliers={[]}
      /> */}
    </>
  );
};

export default OverviewTabs;
